import { render, staticRenderFns } from "./HomeworkSheetEdit.vue?vue&type=template&id=5a07da1e&scoped=true&"
import script from "./HomeworkSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./HomeworkSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkSheetEdit.vue?vue&type=style&index=0&id=5a07da1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07da1e",
  null
  
)

export default component.exports